import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { CustomProduct } from '@product/const';
import { TransitPriceStateService } from '@product/feature';
import { ProductPipesModule } from '@product/utils';
import { RetailRocketCarouselStateService } from '@reference/feature';
import { CurrentProductService } from '@spartacus/storefront';
import { filter, Observable, of, switchMap } from 'rxjs';
import { ProductButtonComponent } from '../../product-button';
import { TransitOrderComponent } from './transit-order';
import { WatchLaterComponent } from './watch-later';

@Component({
  selector: 'sd-add-to-cart',
  imports: [CommonModule, WatchLaterComponent, ProductButtonComponent, TransitOrderComponent, ProductPipesModule],
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToCartComponent {
  private readonly retailRocketCarouselStateService = inject(RetailRocketCarouselStateService, { optional: true });
  private readonly transitPriceStateService = inject(TransitPriceStateService);
  private readonly currentProductService = inject(CurrentProductService);

  readonly product = input<CustomProduct | undefined>(undefined);

  private readonly currentProduct = toSignal(this.currentProductService.getProduct() as Observable<CustomProduct>);

  readonly resolvedProduct = computed(() => this.product() ?? this.currentProduct());

  readonly isRentProduct = computed(() => this.resolvedProduct()?.isRent ?? false);

  readonly transitInstance = toSignal(
    toObservable(this.resolvedProduct).pipe(
      filter(Boolean),
      switchMap((product) => this.transitPriceStateService.getTransitState(product)),
    ),
  );

  readonly transitSwitchState = toSignal(
    toObservable(this.transitInstance).pipe(switchMap((instance) => instance?.switchState$ ?? of(false))),
    { initialValue: false },
  );

  onAddToCart(): void {
    const product = this.resolvedProduct();
    if (product) {
      this.retailRocketCarouselStateService?.clickToAddToCart(product.code);
    }
  }
}
